import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  VehiclesResponse,
  GridRequestDto
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class GetVehiclesCommand extends IRequestCommand<
  IGetVehicleResponse,
  ErrorDetails,
  IGetVehiclesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  override _commandUrl =
    'carriers/{carrierUserId}/vehicles/paginated?page={page}&size={size}&column={column}&sort={sort}&find={find}&enabled={enabled}';
  public override setParameters(parameters: IGetVehiclesCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{find}',
      parameters.find.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{enabled}',
      parameters.enabled?.toString()
    );
  }
}

export interface IGetVehiclesCommandParameters
  extends ICommandParameters,
    GridRequestDto {}

export interface IGetVehicleResponse
  extends VehiclesResponse,
    ICommandResponse {}
